module.exports = __webpack_public_path__ + "static/intersport-2a34bcd17cdfa5f9b0587d23acf38e47.png";